import React from 'react'

export default function Header() {
    return (
        <div className="header">
            <h3>Hyperscale Chat App</h3>
        </div>
    )
}
